import React from 'react';
import { Layout as AntLayout } from 'antd';
import styled from 'styled-components';
import Navigation from './Navigation';

const { Header, Content } = AntLayout;

const StyledLayout = styled(AntLayout)`
  min-height: 100vh;
`;

const StyledHeader = styled(Header)`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: fixed;
  width: 100%;
  z-index: 1000;
  height: 64px;
  padding: 0;
  display: flex;
  align-items: center;
`;

const StyledContent = styled(Content)`
  margin-top: 64px;
  padding: ${({ theme }) => theme.spacing.xl};
  background: ${({ theme }) => theme.colors.secondary};
`;

const Layout = ({ children }) => {
  return (
    <StyledLayout>
      <StyledHeader>
        <Navigation />
      </StyledHeader>
      <StyledContent>{children}</StyledContent>
    </StyledLayout>
  );
};

export default Layout; 